import { MultiLanguage } from 'src/generated/graphql-types';
import store from 'src/redux/config/configureStore';

/**
 * Get the text from the multi language object
 */
export const getTextFromMultiLanguage = (multiLang: MultiLanguage) => {
  if (!multiLang) return '';

  //get the current language
  const { languageContext } = store.getState().general;
  const language: string = languageContext.language;

  //get the text based on the language
  let selectedLanguageText: string = multiLang[language];
  if (selectedLanguageText) return selectedLanguageText;

  //else return the english text or "" if not found
  if (language !== 'en') return multiLang['en'] ?? '';
};
